import { render, staticRenderFns } from "./EditButton.vue?vue&type=template&id=673883b8&scoped=true"
import script from "./EditButton.vue?vue&type=script&lang=js"
export * from "./EditButton.vue?vue&type=script&lang=js"
import style0 from "./EditButton.vue?vue&type=style&index=0&id=673883b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673883b8",
  null
  
)

export default component.exports